export const INVENTORY_2D_API:any=process.env.REACT_APP_API_INVOKE_URL;